import { render, staticRenderFns } from "./CompanyEmailRouteManage.vue?vue&type=template&id=097be5d3"
import script from "./CompanyEmailRouteManage.vue?vue&type=script&lang=js"
export * from "./CompanyEmailRouteManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports